export default __webpack_public_path__ + "static/media/img_1.a8d6a8b8.png";